import { FilterConfig } from './types';
import { i18n } from '@senderra/translations';

export const SELECT_DEFAULT_OPTIONS = [{ value: 'none', title: i18n.t('show-all') }];

const AVAILABLE_STATUSES = {
    active: { value: 'Active', title: 'Active' },
    pending: { value: 'Pending', title: 'Pending' },
} as const;

export const USER_STATUS_OPTIONS = [...SELECT_DEFAULT_OPTIONS, AVAILABLE_STATUSES.active, AVAILABLE_STATUSES.pending];

export const USER_STATE_OPTIONS = [
    ...SELECT_DEFAULT_OPTIONS,
    { value: true, title: 'Locked' },
    { value: false, title: 'Unlocked' },
];

export const DIRECTIONS = {
    ASC: 'asc',
    DESC: 'desc',
} as const;

export const LOGOUT_TIMESTAMP = 'logout-timestamp';
export const LOGOUT_TIMEOUT_MINUTES = 15;

export const commonDataTableFilterConfig: FilterConfig = {
    name: (value: string) => {
        return value
            .split(' ')
            .map(
                (v) =>
                    `(contains(firstName, '${encodeURIComponent(v)}') or contains(lastName, '${encodeURIComponent(
                        v
                    )}'))`
            )
            .join(' and ');
    },
    drugShortNames: (shortNames: string[]) => {
        const shortNamesList = shortNames.map((shortName) => `'${shortName}'`).join(', ');
        return shortNamesList ? `(products/any(p: p/shortName in [${shortNamesList}]))` : '';
    },
    status: (value: string) => `status eq '${value}'`,
    state: (value: boolean) => `isLocked eq ${value}`,
    email: (email: string) => `(email ne '${email}')`,
};

export const FOOTER_HEIGHT = { mobile: '84px', desktop: '52px' };

export const EMPTY_FIELD = ' - ';

export const CONFLICT_ERROR = 409;

export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
] as const;

export const LOGIN_ACTIVITY_KEY = 'login_activity';

export const TIMEZONE = 'CST';
export const DEFAULT_LOCALE = 'en';
